/* eslint-disable no-param-reassign */
import * as Sentry from '@sentry/vue'
import secureAccessCodeApi from '@/api/secureAccessCode'

const _state = {
  accessCode: null,
  uniqueAccessCode: null,
  inFlight: null,
}

const mutations = {
  setSealedCodes(state, { accessCode, uniqueAccessCode }) {
    state.accessCode = accessCode
    state.uniqueAccessCode = uniqueAccessCode
  },
  setInFlight(state, promise) {
    state.inFlight = promise
  },
  reset(state) {
    state.accessCode = null
    state.uniqueAccessCode = null
    state.inFlight = null
  },
}

const actions = {
  async ensureMintedAction({ state, commit, rootState }) {
    if (state.accessCode) return state
    if (state.inFlight) return state.inFlight
    const { accessCode, uniqueAccessCode } = rootState.presentation || {}
    if (!accessCode || !uniqueAccessCode) return state

    const promise = (async () => {
      try {
        const sealed = await secureAccessCodeApi.mintSecuredAccessCode({
          accessCode,
          uniqueAccessCode,
        })
        commit('setSealedCodes', sealed)
      } catch (error) {
        Sentry.captureException(new Error('Secured mode mint failed'), { extra: { error } })
      } finally {
        commit('setInFlight', null)
      }
      return state
    })()
    commit('setInFlight', promise)
    return promise
  },
}

const _getters = {
  securedAccessCode: (state) => state.accessCode,
  securedUniqueAccessCode: (state) => state.uniqueAccessCode,
}

export default {
  namespaced: true,
  state: _state,
  mutations,
  actions,
  getters: _getters,
}
